<template>
  <div class="register-wrapper">
    <login-bar />

    <div class="register-container">
      <el-card class="register-card" shadow="always">
        <div class="register-title">创建账号</div>
        <p class="register-subtitle">加入 tnbapp，开启您的精彩之旅</p>

        <div v-if="registryEnable" class="form-content">
          <el-form ref="registerForm" :model="userRegistry" label-position="top">

            <el-form-item label="账号">
              <div class="input-with-btn">
                <el-input
                    v-model="userRegistry.principal"
                    prefix-icon="el-icon-user"
                    placeholder="手机号或邮箱"
                    clearable
                />
                <el-button
                    class="code-btn"
                    :disabled="isBtn"
                    @click="registerVerifyCode"
                >
                  {{ isBtn ? code + 's' : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label="身份验证码">
              <el-input
                  v-model="userRegistry.verifyCode"
                  prefix-icon="el-icon-chat-dot-round"
                  placeholder="请输入 6 位验证码"
                  clearable
              />
            </el-form-item>

            <el-form-item label="设置密码">
              <el-input
                  v-model="userRegistry.credential"
                  prefix-icon="el-icon-lock"
                  type="password"
                  placeholder="请输入密码"
                  show-password
                  clearable
              />
            </el-form-item>

            <el-form-item label="安全验证">
              <div class="captcha-box">
                <el-input
                    v-model="userRegistry.captchaCode"
                    placeholder="图形验证码"
                    @keyup.enter.native="registerBtn"
                />
                <el-image
                    class="captcha-img"
                    :src="captchaCode"
                    title="点击刷新"
                    @click="getCaptcha"
                />
              </div>
            </el-form-item>

            <div class="action-buttons">
              <el-button
                  type="primary"
                  class="submit-btn"
                  :loading="isLoading"
                  @click.native="registerBtn"
              >
                立即注册
              </el-button>
              <div class="footer-link">
                <span>已有账号？</span>
                <el-button type="text" @click="login">返回登录</el-button>
              </div>
            </div>
          </el-form>
        </div>

        <div v-else class="disabled-status">
          <i class="el-icon-warning-outline"></i>
          <p>抱歉，系统当前未开放注册</p>
          <el-button type="primary" plain round @click="login" class="mt-20">返回登录</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import LoginBar from 'components/layout/LoginBar'
import { getRegistryStatus } from '@/api/account'

export default {
  name: 'Register',
  components: { LoginBar },
  mixins: [userMixin],
  data() {
    return {
      registryEnable: false
    }
  },
  created() {
    document.title = '注册帐号'
    this.getData()
  },
  methods: {
    getData() {
      getRegistryStatus().then(resp => {
        if (resp.code === 0) {
          this.registryEnable = resp.data
          if (this.registryEnable) {
            this.fetchPubkey(2)
          }
        }
      })
    },
    login() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.register-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  flex-direction: column;
}

.register-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.register-card {
  width: 100%;
  max-width: 440px;
  border-radius: 12px;
  border: none;
  padding: 10px 15px;
}

.register-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.register-subtitle {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin-bottom: 25px;
}

/* 布局辅助 */
.input-with-btn {
  display: flex;
  gap: 10px;
}

.code-btn {
  width: 120px;
  flex-shrink: 0;
}

.captcha-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-img {
  width: 110px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

/* 按钮区 */
.action-buttons {
  margin-top: 30px;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.footer-link {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #606266;
}

/* 禁用状态样式 */
.disabled-status {
  text-align: center;
  padding: 40px 0;
}

.disabled-status i {
  font-size: 48px;
  color: #E6A23C;
  margin-bottom: 15px;
}

.disabled-status p {
  color: #606266;
  font-size: 16px;
}

.mt-20 { margin-top: 20px; }

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .register-card {
    box-shadow: none;
    background: transparent;
  }
  .register-container {
    align-items: flex-start;
    padding-top: 40px;
  }
}

/* Element UI 样式覆盖 */
::v-deep .el-form-item__label {
  padding-bottom: 4px;
  font-weight: 500;
}
</style>
